import axios from 'axios';

import { FunctionProps, UnwrapPromise } from '@utils/types';
import type { Services } from '@api/remote-services-registry';
import { normalizeApiErrors } from '@utils/api/customErrorHandler';
import { generateUUID } from '@utils/generateUUID';

const getRequestHeaders = (authorization: string): Record<string, string> => {
  const token = (typeof window !== 'undefined' && authorization) || '';
  const basketId =
    (typeof window !== 'undefined' && localStorage.getItem('basketId')) || '';
  const cid = generateUUID();
  return { token, authorization: token, correlationId: cid, basketId };
};

export async function callService<
  Version extends keyof Services = 'v1',
  S extends keyof Services[Version] = keyof Services[Version],
  M extends FunctionProps<Services[Version][S]> = FunctionProps<
    Services[Version][S]
  >
>(
  {
    service,
    method,
    version,
  }: {
    service: S;
    method: M;
    version?: Version;
  },
  ...args: Services[Version][S][M] extends (...args: infer Args) => unknown
    ? Args
    : never
) {
  const token = args?.[0]?.['authorization'] ?? '';
  if (token) delete args?.[0]?.['authorization'];

  const versionPath = version ? `${version}/` : '';
  const path = `/api/services/${versionPath}${service as string}/${
    method as string
  }`;

  const headers = getRequestHeaders(token);

  let result: UnwrapPromise<Services[Version][S][M]>;

  try {
    const { data } = await axios.post<UnwrapPromise<Services[Version][S][M]>>(
      path,

      { args },
      { headers }
    );
    result = data;
  } catch (e) {
    result = e.response.data as UnwrapPromise<Services[Version][S][M]>;
  }
  return normalizeApiErrors(result);
}
